export enum OrderLineType {
  Unknown = 0,
  Item = 1,
  Text = 2,
  NotToBePrinted = 3
}
